import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './CustomerHeader.css';
import { injectIntl } from 'react-intl';
import { intlText } from '../../../utils/text-util';
import { MEDIUM_SCREEN_THRESHOLD } from '../../../constants/constants';
import { Select, FormControl, MenuItem, Dialog, DialogTitle, DialogActions, DialogContent, Button, TextField } from '@material-ui/core';

const BASE_PRICE_MULTIPLIER = 100;

const generatePriceIncreaseOptions = (maxPriceIncrease, currentValue) => {
  const options = [];

  for(let i = 5; i>=-5; i--) {
      options.push({
        label: `${i}%`,
        value: 0.01 * i
      })
  }

  options.push({
    label: 'Custom',
    value: 'custom'
  });

  const isInRange = options.some(opt => opt.value === currentValue);
  if(
    typeof currentValue === 'number' &&
    !isInRange &&
    currentValue !== Number.MIN_SAFE_INTEGER
  ) {
    options.unshift({
      label: `${(currentValue * 100).toFixed(2)}%`,
      value: currentValue
    })
  }

  return options;
};

const generateCustomerDiv = (
  props,
  showCustomModal,
  setShowCustomModal,
  customPrice,
  setCustomPrice
) => (
  <div className="col-xs-6 col-md-3 col-lg-3 customer-info-row-data customer-info-header-div">
    <label> {props.intl.formatMessage({ id: 'customer' })}: </label>
    <b>{props.customer.deliverToCustomerName}</b>
    <br />
    {!!props.renewalTermYears ? (
      <span>
<label>{intlText(props, 'renewal_term')}: </label>
<b>
{`${props.renewalTermYears} ${props.intl.formatMessage({
  id: 'years'
})}`}
</b>
<br />
</span>
    ) : null}
    {props.showPriceIncreaseDropdown ? (
      <div>
        <label> {props.intl.formatMessage({ id: 'price_increase' })}: </label>
        <form className="priceIncreaseForm">
          <FormControl className="priceIncreaseSelect">
            <Select
              value={props.renewalPriceIncrease}
              onChange={(event) => {
                const value = event.target.value;
                if (value === 'custom') {
                  setShowCustomModal(true);
                } else {
                  props.onPriceChange({ target: { value } });
                }
              }}
              inputProps={{
                name: 'priceIncrease',
                id: 'priceIncreaseOptions'
              }}
            >
              {generatePriceIncreaseOptions(props.maxBasePriceIncrease, props.renewalPriceIncrease).map(
                (option, index) => (
                  <MenuItem key={index} value={option.value}>
                    {option.label}
                  </MenuItem>
                )
              )}
            </Select>
          </FormControl>
        </form>
        <Dialog open={showCustomModal} onClose={() => setShowCustomModal(false)}>
          <DialogTitle>Custom Price Adjustment</DialogTitle>
          <DialogContent>
            <TextField
              label="Price Adjustment (%)"
              type="number"
              fullWidth
              value={customPrice}
              onChange={(e) => setCustomPrice(e.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setShowCustomModal(false)}>Cancel</Button>
            <Button
              color="primary"
              onClick={() => {
                const parsedValue = parseFloat(customPrice) / 100;
                if (!isNaN(parsedValue)) {
                  props.onPriceChange({ target: { value: parsedValue } });
                }
                setShowCustomModal(false);
              }}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    ) : null}
  </div>
);

const generateBillToDiv = (props) => (
  <div className="col-xs-6 col-md-3 col-lg-3 customer-info-row-data customer-info-header-div">
    <label> {props.intl.formatMessage({ id: 'bill_to' })}</label>
    <br /># <b>{props.customer.billToCustomerNumber}</b>
    <br />
    <span className="address-span">{props.customer.fullBillingAddress}</span>
  </div>
);

const generateDeliverToDiv = (props) => (
  <div className="col-xs-6 col-md-3 col-lg-3 customer-info-row-data customer-info-header-div">
    <label> {props.intl.formatMessage({ id: 'deliver_to' })}</label>
    <br /># <b>{props.customer.deliverToCustomerNumber}</b>
    <br />
    <span className="address-span">{props.customer.fullDeliveryAddress}</span>
  </div>
);

const generateRouteDiv = (props) => (
  <div className="col-xs-6 col-md-3 col-lg-3 customer-info-row-data customer-info-header-div">
    <label> {props.intl.formatMessage({ id: 'route' })}: </label>

    <b>{props.customer.routeNumber}</b>
    <br />
    <label> {props.intl.formatMessage({ id: 'district' })}: </label>

    <b>{props.customer.district.description}</b>
  </div>
);

const CustomerHeader = (props) => {
  const [showCustomModal, setShowCustomModal] = useState(false);
  const [customPrice, setCustomPrice] = useState('');

  return (
    <div className="customer-info-row row">
      {window.innerWidth > MEDIUM_SCREEN_THRESHOLD ? (
        <>
          {generateCustomerDiv(
            props,
            showCustomModal,
            setShowCustomModal,
            customPrice,
            setCustomPrice
          )}
          {generateBillToDiv(props)}
          {generateDeliverToDiv(props)}
          {generateRouteDiv(props)}
        </>
      ) : (
        <>
          {generateCustomerDiv(
            props,
            showCustomModal,
            setShowCustomModal,
            customPrice,
            setCustomPrice
          )}
          {generateRouteDiv(props)}
          {generateBillToDiv(props)}
          {generateDeliverToDiv(props)}
        </>
      )}
    </div>
  );
};

CustomerHeader.propTypes = {
  customer: PropTypes.object.isRequired,
  renewalPriceIncrease: PropTypes.number,
  showSave: PropTypes.bool,
  onPriceChange: PropTypes.func,
  renewalTermYears: PropTypes.number,
  showPriceIncreaseDropdown: PropTypes.bool,
  maxBasePriceIncrease: PropTypes.number
};

export default injectIntl(CustomerHeader);
